<template>
  <div class="home-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'HomeView'
}
</script>

<style scoped>
.home-container {
  width: 100%;
  height: 100%;
  overflow: auto;
}
</style>
